export default {
  solutions: {
    breadcrumbHome: 'Startseite',
    breadcrumbCurrent: 'Lösungen',
    hero: {
      eyebrow: 'Lösungen',
      title: 'Die passende Lösung für jedes Objekt',
      lead: 'Ob Privathaus, Ladenfläche oder Lagerhalle – wir finden gemeinsam die optimale Kameraanlage für Ihre Anforderungen.',
    },
    grid: {
      eyebrow: 'Objektlösungen im Überblick',
      title: 'Sechs Bereiche – ein Anspruch: echte Sicherheit',
      lead: 'Jede Karte führt zu einer eigenen Übersicht mit typischen Überwachungspunkten und passenden Technik-Lösungen.',
    },
    tag: { privat: 'Privat', gewerbe: 'Gewerbe', innen: 'Innen', außen: 'Außen', neu: 'Neu', erweiterung: 'Erweiterung' },
    more: 'Mehr erfahren',
    cta: {
      title: 'Nicht sicher, welche Lösung passt?',
      lead: 'Wir analysieren Ihr Objekt gemeinsam und empfehlen Ihnen die passende Kombination aus Kameras, Aufzeichnung und Zubehör.',
      primary: 'Unverbindlich beraten lassen',
      secondary: 'KameraPlaner starten',
    },
  },
};